interface FieldMeta {
  label: string;
  unit?: string;
  kind?: "boolean" | "sensor" | "durationHours" | "durationMinutes" | "durationSeconds";
}

/** Labels/units for device history payload and change fields. */
export const HISTORY_FIELD_META: Record<string, FieldMeta> = {
  temp: { label: "Temperature", unit: "°C" },
  orp: { label: "ORP", unit: "mV" },
  ph: { label: "pH" },
  salinity: { label: "Salinity", unit: "ppm" },
  cell: { label: "Cell output", unit: "%" },
  vsdPumpSpeed: { label: "VSD pump speed" },
  boostDuration: { label: "Boost duration", unit: "h", kind: "durationHours" },
  backwashDuration: {
    label: "Backwash duration",
    unit: "min",
    kind: "durationMinutes",
  },
  orpConnected: { label: "ORP sensor", kind: "sensor" },
  phConnected: { label: "pH sensor", kind: "sensor" },
  salinityConnected: { label: "Salinity sensor", kind: "sensor" },
  tempConnected: { label: "Temperature sensor", kind: "sensor" },
  isVsdPumpConnected: { label: "VSD pump", kind: "sensor" },
  acidPump: { label: "Acid pump" },
  heatPump: { label: "Heat pump" },
  heatpump: { label: "Heat pump" },
  poolSize: { label: "Pool size", unit: "L" },
  region: { label: "Region" },
  mode: { label: "Mode" },
  schedules: { label: "Schedules" },
};

export function humanizeFieldKey(field: string): string {
  return field
    .replace(/([A-Z])/g, " $1")
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();
}

export function formatScalarValue(
  field: string,
  value: unknown,
): string | null {
  if (value === undefined) return null;
  if (value === null || value === "") return "cleared";

  const meta = HISTORY_FIELD_META[field];
  if (typeof value === "boolean") {
    if (meta?.kind === "sensor") return value ? "connected" : "disconnected";
    return value ? "on" : "off";
  }

  if (typeof value === "number" || typeof value === "string") {
    const unit = meta?.unit ? ` ${meta.unit}` : "";
    return `${value}${unit}`.trim();
  }

  return String(value);
}
